'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/gopd/gOPD.js
// module id = 5617
// module chunks = 0